module.exports = __webpack_public_path__ + "img/payment-icon.ed5f2543.png";